/**
 * 协同平台类型。
 *
 * <p>编号与 System 服务的 CollaborationPlatformEnum 保持一致，业务代码不得直接使用平台数字。</p>
 */
export enum CollaborationPlatform {
    DINGTALK = 20,
    WXCP = 30,
    FEISHU = 40
}

export type CollaborationLoginMode = 'AUTHORIZE' | 'PASSWORD' | 'PLATFORM_MISMATCH' | 'UNAVAILABLE'

export interface CollaborationLoginResolveResponse {
    mode: CollaborationLoginMode
    platform?: CollaborationPlatform
    authorizeUrl?: string
}

export interface CollaborationLoginSession {
    returnUrl: string
    startedAt: number
}
